export enum LocalStorageKeys {
    LANGUAGE = 'language',
    TOKEN = 'token',
    ACCESSTOKEN = 'accessToken',
    IDTOKEN = 'idToken',
    OPENMODAL = 'open_modal',
    TOKENTIMESTAMP = 'tokenTimestamp',
    SELECTEDDATE = 'selectedDate',
    SELECTEDZONE = 'selectedZone',
    TOKENEXPIRATION = 'token_expiration',
    SERVICEHISTORYDATERANGE = 'serviceHistoryDateRange',
    PENDINGSERVICESDATERANGE = 'pendingServicesDateRange',
    WEEKLYGANTTFILTERS = 'freelanceGanttWeekly',
    PENDINGSERVICESFILTERS = 'pendingServicesFilters',
    SERVICEHISTORYFILTERS = 'serviceHistoryFilters',
    SERVICESNOTSTARTEDFILTERS = 'servicesNotStartedTableFilters',
    EXPENSESFILTERS = 'expensesFilters'
}
  